export default __webpack_public_path__ + "static/media/illustration-study-2-n-w@2x.37f83227.webp";